import { BodyBox, EntityForm, NotFoundPage, Notice } from '@lbcamden/lib-react';
import { DateTime } from 'luxon';
import { FunctionComponent } from 'react';
import { useParams } from 'react-router';

import { useProperty, useUserStore } from '~/client/hooks/storeHooks';
import { useGoBackOrNavigate } from '~/client/hooks/useGoBackOrNavigate';
import { getPropertyBreadcrumbs, toPropertyPage } from '~/client/utils/navigation';

import { PageBreadcrumbs } from '../../shared/PageBreadcrumbs';
import {
  useConvertVisitFormData,
  getVisitFormConfig,
  visitFormSchema,
  VisitFormValues,
} from './config';

const title = 'Log visit';

export const PropertyVisitCreatePage: FunctionComponent = () => {
  const navigate = useGoBackOrNavigate();
  const { propertyId: propertyIdParam } = useParams();

  const userStore = useUserStore();
  const property = useProperty(propertyIdParam!);

  const convert = useConvertVisitFormData({ propertyId: Number(propertyIdParam) });

  const onCancel = () => navigate(toPropertyPage(propertyIdParam!));

  const onSave = (data: VisitFormValues) => {
    const payload = convert.fromForm(data);

    userStore?.handleAndDispatchMessage('logVisit', payload.visitId, payload);
    void navigate(toPropertyPage(propertyIdParam!));
  };

  if (!property) {
    return <NotFoundPage />;
  }

  return (
    <BodyBox>
      <PageBreadcrumbs
        css={{ marginBottom: 0 }}
        links={[...getPropertyBreadcrumbs(property), { name: title }]}
      />
      <EntityForm
        title={title}
        message={
          <Notice infoWithIcon>
            Logging a successful visit will automatically close any open “Visiting Programme” cases
          </Notice>
        }
        initialValue={convert.toForm({ timestamp: DateTime.now().toISO() })}
        schema={visitFormSchema}
        config={getVisitFormConfig()}
        onCancel={onCancel}
        onSave={onSave}
      />
    </BodyBox>
  );
};
